import ENV from './env';
import Http from './config/http';

function getAccessToken() {
  return localStorage.getItem('access_token');
}

function getUserType(kind) {
  const userType = localStorage.getItem('type');

  switch (userType) {
    case 'Account':
      return kind === 'api_url' ? 'accounts' : 'account';
    case 'User':
      return kind === 'api_url' ? 'users' : 'user';
    default:
      return '';
  }
}

export default {
  // * .json 是給 ERP 這是 json 格式

  /**
   * User Sign In 
   */
  signInUser(userData) {
    return Http({
      method: 'post',
      url: `${ENV.ERP_PORT}/sign_in.json`,
      data: {
        user: {
          email: userData.email,
          password: userData.password,
        },
      },
      headers: {
        remoteSystem: 'OBM',
      },
    });
  },

  /**
   * User Forget Password
   */
  forgetPasswordUser(email) {
    return Http({
      method: 'post',
      url: `${ENV.ERP_PORT}/users/password.json`,
      data: {
        user: {
          email,
        },
      },
      headers: {
        remoteSystem: 'OBM',
      },
    });
  },

  /**
   * User Reset Password
   */
  resetPasswordUser(newpw, confirmpw, token) {
    return Http({
      method: 'put',
      url: `${ENV.ERP_PORT}/accounts/password.json`,
      data: {
        account: {
          password: newpw,
          password_confirmation: confirmpw,
          reset_password_token: token,
        },
      },
      headers: {
        remoteSystem: 'OBM',
      },
    });
  },

  /**
   * User Update Password
   */
  updatePasswordUser(oldpw, confirmpw, newpw, token) {
    return Http({
      method: 'put',
      url: `${ENV.ERP_PORT}/${getUserType('api_url')}.json`,
      params: {
        access_token: getAccessToken(),
      },
      data: {
        [getUserType()]: {
          current_password: oldpw,
          password: newpw,
          password_confirmation: confirmpw,
        },
        access_token: token,
      },
      headers: {
        remoteSystem: 'OBM',
      },
    });
  },

  /**
   * User Check Account
   */
  checkAccount(verificationCode) {
    return Http({
      method: 'post',
      url: `${ENV.ERP_PORT}/reverify?verification_code=${verificationCode}`,
      headers: {
        remoteSystem: 'OBM',
      },
    });
  },

};



// WEBPACK FOOTER //
// ./src/services/user.js